import * as React from "react";
const SvgPause = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="#1A1C22"
      d="M6.667 4h1.666c.442 0 .866.21 1.179.586C9.824 4.96 10 5.47 10 6v12c0 .53-.176 1.04-.488 1.414-.313.375-.737.586-1.179.586H6.667c-.442 0-.866-.21-1.179-.586A2.22 2.22 0 0 1 5 18V6c0-.53.176-1.04.488-1.414C5.801 4.21 6.225 4 6.667 4M15.667 4h1.666c.442 0 .866.21 1.179.586C18.824 4.96 19 5.47 19 6v12c0 .53-.176 1.04-.488 1.414-.313.375-.737.586-1.179.586h-1.666c-.442 0-.866-.21-1.179-.586A2.22 2.22 0 0 1 14 18V6c0-.53.176-1.04.488-1.414.313-.375.737-.586 1.179-.586"
    />
  </svg>
);
export default SvgPause;
